import { isOn } from './helpers.js';
export const isToBigInt = /*#__PURE__*/ isOn('toBigInt');
